module.exports = __webpack_public_path__ + "9570f64d4dcee2cd3a4cfabb955844e1.png";